const bannersTSReducer = (data = [], action) => {	
  if (action.type === 'FETCH_BANNERS_TS_LIST') {
    return action.payload;
  }
  return data;
};

export default bannersTSReducer